import { CliError } from "@/lib/cli/cli-error";
import { CLI_ERROR_CODES } from "@/lib/shared/errors-constants";
import { RETRYABLE_FOLLOW_STATUS } from "./follow-retry-constants";

export function retryableFollowError(error: unknown): error is CliError {
  return (
    error instanceof CliError &&
    (RETRYABLE_FOLLOW_STATUS.has(error.details.status ?? 0) ||
      error.details.code === CLI_ERROR_CODES.NETWORK ||
      error.details.code === CLI_ERROR_CODES.TIMEOUT)
  );
}
